export function IlustracaoCalendario(props) {
  return (
    <svg
      width={70}
      height={71}
      viewBox="0 0 70 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.745 57.48c14.172 1.543 55.457-12.99 38.107-37.214-17.349-24.224-50.338.353-52.043 14.9C5.108 49.712 10.41 56.356 20.745 57.48z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8 50.634h31.026V19.705H17.8v30.93z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.58 47.826c0 5.94-4.814 10.754-10.754 10.754-5.94 0-10.754-4.815-10.754-10.754 0-5.939 4.815-10.754 10.754-10.754 5.94 0 10.755 4.815 10.755 10.754z"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.248 29.116h1.887V27.23h-1.886v1.886zM40.864 29.116h1.886V27.23h-1.886v1.886zM35.248 34.731h1.887v-1.886h-1.886v1.886zM40.864 34.731h1.886v-1.886h-1.886v1.886zM35.248 40.346h1.887V38.46h-1.886v1.886zM29.249 29.116h1.886V27.23h-1.886v1.886zM29.249 34.731h1.886v-1.886h-1.886v1.886zM29.249 40.346h1.886V38.46h-1.886v1.886zM23.249 29.116h1.886V27.23h-1.886v1.886zM23.249 34.731h1.886v-1.886h-1.886v1.886zM23.249 40.346h1.886V38.46h-1.886v1.886z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.056 21.154v1.404a.944.944 0 001.887 0v-1.404a.46.46 0 01.46-.461h2.808a.46.46 0 01.46.461v1.404a.944.944 0 001.886 0v-1.404a.46.46 0 01.462-.461h1.404a.46.46 0 01.46.461v11.23a.944.944 0 001.886 0V19.75a.945.945 0 00-.944-.943H46.02a.46.46 0 01-.462-.461v-1.404a.943.943 0 00-1.886 0v1.404a.46.46 0 01-.46.461h-2.807a.46.46 0 01-.462-.461v-1.404a.943.943 0 00-1.886 0v1.404a.46.46 0 01-.46.461h-2.807a.46.46 0 01-.462-.461v-1.404a.943.943 0 00-1.886 0v1.404a.461.461 0 01-.46.461h-2.809a.46.46 0 01-.46-.461v-1.404a.944.944 0 00-1.886 0v1.404a.46.46 0 01-.46.461h-2.808a.461.461 0 01-.462-.461v-1.404a.943.943 0 00-1.886 0v1.404a.46.46 0 01-.46.461h-2.808a.944.944 0 00-.942.943v30.884c0 .519.422.943.942.943h15.443a.945.945 0 000-1.887H19.347a.46.46 0 01-.462-.46V21.154a.46.46 0 01.461-.461h1.404a.46.46 0 01.46.461v1.404a.944.944 0 001.886 0v-1.404c0-.255.207-.461.462-.461h2.808a.46.46 0 01.46.461v1.404a.945.945 0 001.887 0v-1.404a.46.46 0 01.46-.461h2.808c.253 0 .46.206.46.461v1.404a.944.944 0 001.886 0v-1.404a.46.46 0 01.462-.461h2.806a.46.46 0 01.462.461z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.826 58.113c-5.672 0-10.287-4.614-10.287-10.287 0-5.673 4.615-10.287 10.287-10.287 5.673 0 10.288 4.614 10.288 10.287 0 5.673-4.615 10.287-10.288 10.287zm0-22.46c-6.712 0-12.173 5.461-12.173 12.173S42.113 60 48.826 60 61 54.538 61 47.826s-5.461-12.174-12.174-12.174z"
        fill="#B3472E"
      />
    </svg>
  );
}
